// 混入 (mixin) 提供了一种非常灵活的方式，来分发 Vue 组件中的可复用功能。
import Vue from "vue";
import { get_safeinfo } from "@/api/set";

Vue.mixin({
  data() {
    return {};
  },
  methods: {
    // 设置表头颜色
    setTableHeader({ rowIndex }) {
      if (rowIndex === 0) {
        return {
          background: "rgba(250,250,250,1)",
          color: "#000000"
        };
      } else {
        return {};
      }
    },
    async get_prosms_ob() {
      try {
        var data = { app_id: this.app_id };
        const res = await get_safeinfo(data);
        if (res.code == 200) {
          let data = res.data;
          for (let i in res.data) {
            res.data[i] = res.data[i].toString();
          }
          return res.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    mydateFormat(time) {
      var t = new Date(time * 1000);
      var yy = t.getFullYear();
      var mm = t.getMonth() + 1;
      var dd = t.getDate();
      var h = t.getHours();
      var m = t.getMinutes();
      var s = t.getSeconds();
      mm = mm < 10 ? "0" + mm : mm;
      dd = dd < 10 ? "0" + dd : dd;
      h = h < 10 ? "0" + h : h;
      m = m < 10 ? "0" + m : m;
      s = s < 10 ? "0" + s : s;
      return yy + "-" + mm + "-" + dd + " " + h + ":" + m + ":" + s;
    }
  }
});
